import { sunoCommsApi } from "../api-base";
import type {
  LandingPage,
  LandingPageCreate,
  LandingPageFilter,
  LandingPageUpdate,
  PaginatedLandingPagesResponse
} from "../types/landing-page.type";

const BASE = "/landing-pages";

export const landingPagesEndpoints = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getLandingPages: builder.query<
      PaginatedLandingPagesResponse,
      LandingPageFilter | void
    >({
      // RTK drops `undefined` params; `is_active: null` is sent verbatim (= both).
      query: (filter = {}) => ({
        url: `${BASE}/`,
        params: { limit: 100, skip: 0, order: "-created_at", ...filter }
      }),
      providesTags: ["LandingPages"]
    }),
    getLandingPage: builder.query<LandingPage, string>({
      query: (id) => `${BASE}/${id}`,
      providesTags: (_result, _error, id) => [{ type: "LandingPage", id }]
    }),
    createLandingPage: builder.mutation<LandingPage, LandingPageCreate>({
      query: (body) => ({ url: `${BASE}/`, method: "POST", body }),
      invalidatesTags: ["LandingPages"]
    }),
    updateLandingPage: builder.mutation<
      LandingPage,
      LandingPageUpdate & { id: string }
    >({
      query: ({ id, ...body }) => ({
        url: `${BASE}/${id}`,
        method: "PATCH",
        body
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "LandingPage", id },
        "LandingPages"
      ]
    }),
    cloneLandingPage: builder.mutation<LandingPage, string>({
      query: (id) => ({ url: `${BASE}/${id}/clone`, method: "POST" }),
      invalidatesTags: ["LandingPages"]
    }),
    deleteLandingPage: builder.mutation<void, string>({
      query: (id) => ({ url: `${BASE}/${id}`, method: "DELETE" }),
      invalidatesTags: ["LandingPages"]
    })
  })
});

export const {
  useGetLandingPagesQuery,
  useGetLandingPageQuery,
  useCreateLandingPageMutation,
  useUpdateLandingPageMutation,
  useCloneLandingPageMutation,
  useDeleteLandingPageMutation
} = landingPagesEndpoints;
